<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :class="{ is_index: isHome }">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/images/ic_nav_logo@2x.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0" 
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <div v-if="item.children.length > 0" class="s-nav-content">
            <div class="s-nav-item abs" v-if="item.name === '关于华辉'" >
              <ul class="s-nav-ul">
                <li v-for="(el, x) in item.children" :key="x">
                  <router-link :to="el.path">{{ el.name }}</router-link>
                </li>
              </ul>
            </div>
            <div class="s-nav-item" v-else v-for="(i, n) in item.children" :key="n">
              <div class="title">{{ i.name }}</div>
              <ul class="s-nav-ul" v-if="i.children.length > 0">
                <li v-for="(el, x) in i.children" :key="x">
                  <router-link :to="`${el.path}?id=${el.id}`">{{ el.name }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <!-- 导航搜索 -->
      <div class="header-nav-search-content">
        <div class="header-nav-search" :class="{'no-border': isHome}">
          <input v-model="keyword" placeholder="请输入搜索内容" class="input" @keyup.enter="searchSub" type="text" />
          <img
            v-if="isHome"
            class="search_btn"
            src="@/assets/images/ic_nav_search@2x.png"
            alt="搜索"
            @click="searchSub"
          />
          <img
            v-else
            class="search_btn"
            src="@/assets/images/ic_nav_search@2x_2.png"
            alt="搜索"
            @click="searchSub"
          />
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- <div class="header-nav-m-menus" :class="{'open': open_menus}">
        <div class="logo">
          <img
            class="center-block"
            src="@/assets/images/ic_nav_logo@2x.png"
            alt="logo"
          />
        </div>
        <div class="icon" @click="openMenus()">
          <img v-if="!open_menus" src="@/assets/images/mobile/ic_nav_more_white.svg" alt="" />
          <img v-else src="@/assets/images/mobile/ic_nav_close.svg" alt="" />
        </div>
      </div> -->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu" :class="{'open': open_menus}">
        <div class="logo">
          <img
            class="center-block"
            src="@/assets/images/ic_nav_logo@2x.png"
            alt="logo"
          />
        </div>
        <div class="icon" @click="openMenus()" data-target="#menu" data-toggle="collapse">
          
          
          <img v-if="isHome && !open_menus" src="@/assets/images/mobile/ic_nav_more_white.svg" alt="" />
          <img v-else-if="!isHome && !open_menus" src="@/assets/images/mobile/ic_nav_more.svg" alt="" />
          <img v-else src="@/assets/images/mobile/ic_nav_close.svg" alt="" />
          
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index === navIndex ? 'active' : ''"
            @click="navMClick(item, index)"
          >
          <div class="menu-link">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
            <img src="@/assets/images/mobile/ic_more.svg" alt="">
          </div>
          <div class="m-sub-menus" v-if="item.children.length > 0 && item.open">
            <ul>
              <li :class="n===secondNavindex ? 'active' : ''" @click.stop="navMClick(i, n, 'second')" v-for="(i, n) in item.children" :key="n">
                <div class="menu-link">
                  <router-link :to="item.path">
                    {{ i.name }}
                    <i class="underline"></i>
                  </router-link>
                  <img src="@/assets/images/mobile/ic_more.svg" alt="">
                </div>
                <div class="m-sub-menus" v-if="i.children.length > 0 && i.open">
                  <ul>
                    <li :class="x===threeNavindex ? 'active' : ''" @click.stop="navMClick(el, x, 'three')" v-for="(el, x) in i.children" :key="x">
                      <div class="menu-link">
                        <router-link :to="`${el.path}?id=${el.id}`">
                          {{ el.name }}
                          <i class="underline"></i>
                        </router-link>
                        <img src="@/assets/images/mobile/ic_more.svg" alt="">
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
            
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  props: ["isHome", "data"],
  data() {
    return {
      keyword: '',
      open_menus: false, 
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      secondNavindex: '',
      threeNavindex: '',
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
      ],
    };
  },
  watch:{
    data(val) {
      this.navList = this.transNav(val)
    }
  },
  mounted() {
    this.keyword = localStorage.getItem('searchKeyword');
  },
  methods: {
    // 搜索提交
    searchSub() {
      const { name } = this.$route;
      localStorage.setItem('searchKeyword', this.keyword)
      this.$router.push('news_center?keyword='+this.keyword)
      setTimeout(()=> {
        if(name === 'news_center') {
          location. reload()
        }
      }, 500)
    },
    transNav(list) {
      const result = []
      // 遍历 menus
      if (list && list.length) {
        list.forEach((item) => {
          // 解构赋值
          let {
            category_id: id,
            category_name: name ,
            href_url: path,
            children: children,
          } = item

          // 如果有子节点，递归
          if (children) {
            children = this.transNav(children)
          } else {
            children = []
          }
          result.push({
            id,
            name,
            path: path ? '/'+path : '',
            children
          })
        })
      }
      return result
    },
    // 移动端打开、关闭菜单
    openMenus() {
      this.open_menus = !this.open_menus
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    // 移动端点击
    navMClick(item, index, type) {
      console.log('item', item);
      const { open, name } = item;
      if (type) {
        // this.navIndex = 2;
        // sessionStorage.setItem("navIndex", 2);
        if(type === 'three') {
          this.threeNavindex = index;
        } else if (type === 'second') {
          this.secondNavindex = index
        }
      }else {
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
      }
      this.setMenuAttr(name, 'open', !open)
      if (!item.children || !item.children.length) {
        console.log('打开菜单');
        this.$router.push(item.path+'?id='+item.id);
        this.openMenus()
        document.getElementById('menu').style.height = 0;
        document.getElementById('menu').className += 'in';
      }
    },
    // 遍历菜单中匹配到的值
    setMenuAttr(name, key, value) {
      const list = JSON.parse(JSON.stringify(this.navList));
      const m =(arr)=> arr.map(item=> {
        // item.open = false
        if(item.name === name) item[key] = value;
        if(item.children && item.children.length) {
          m(item.children)
        }
      })
      m(list)
      this.$nextTick(function () {
        // this.$set(this.navList, '', list)
        this.navList = list
      })
      console.log('----', list);
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped lang="less">
a {
  text-decoration: none !important;
}
@import '../assets/css/styles';
/* 顶部 */
#header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  transition: all ease 0.6s;
  z-index: 99999;
}
#header.is_index {
  background: rgba(255, 255, 255, 0.34);
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: rgba(255, 255, 255, 0.3);
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 80px;
  width: 1340px;
  display: flex;
  justify-content: space-between;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 208px;
  height: 100%;
  /* float: left; */
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 208px;
  height: 58px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  /* float: right; */
  margin: 0;
  max-width: 800px;
}
#header .glyphicon {
  font-family: 'Glyphicons Halflings';
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 20px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #666;
  font-size: 15px;
  padding: 15px 0;
  position: relative;
  font-weight: 400;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #eb0029;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover, #header .header-nav .header-nav-wrapper > li > a:focus {
  color: #eb0029;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #eb0029;
  text-decoration: none;
  border-bottom: 2px solid #eb0029;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > .s-nav-content {
  display: none;
  position: absolute;
  // top: 80%;
  left: -20px;
  z-index: 999999;
  // box-shadow: 0 0 3px 1px #ccc;
  background: rgb(255 255 255 / 83%);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > .s-nav-content > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > .s-nav-content > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover .s-nav-content {
  display: flex;
}
#header .header-nav .header-nav-wrapper > li > .s-nav-content > dt:hover {
  cursor: pointer;
  background: #ccc;
}
#header.is_index .header-nav .header-nav-wrapper > li > a {
  color: #fff !important;
}
/* 导航栏搜索 */
.header-nav-search-content {
  height: 100%;
  /* float: right; */
  display: flex;
  align-items: center;
}
.header-nav-search {
  width: 220px;
  height: 38px;
  background: rgba(255, 255, 255, 0.34);
  border-radius: 20px;
  border: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  &.no-border {
    border: none;
  }
}
.header-nav-search .input {
  width: 100%;
  flex: 1;
  font-weight: 400;
  color: #B4B4B4;
  line-height: 20px;
  font-size: 14px;
  border: transparent;
  background: transparent;
  outline: none;
}
.header-nav-search input::-webkit-input-placeholder {
  color: #B4B4B4;
}
#header.is_index .header-nav-search .input {
  color: #ffffff;
}
#header.is_index .header-nav-search input::-webkit-input-placeholder {
  color: #ffffff;
}
.header-nav-search .search_btn {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
@media screen and (max-width: 997px) {
  // #header .header-nav-m {
  //   position: relative;
  // }
  // /* 导航栏logo容器 */
  // #header .header-nav-m .header-nav-m-logo {
  //   height: 80px;
  //   position: relative;
  // }
  /* 导航栏logo图片 */
  // #header .header-nav-m .header-nav-m-logo img {
  //   width: 95px;
  //   height: 45px;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   margin: auto;
  // }
  /* 导航栏  菜单容器 */
  // #header .header-nav-m .header-nav-m-menu {
  //   color: #fff;
  //   height: 50px;
  //   font-size: 20px;
  //   line-height: 50px;
  //   position: relative;
  // }
  // /* 导航栏 菜单图标 */
  // #header .header-nav-m .header-nav-m-menu-wrapper {
  //   position: absolute;
  //   top: 50%;
  //   right: 20px;
  //   margin-top: -20px;
  //   width: 50px;
  //   height: 40px;
  //   color: #fff;
  //   z-index: 999999;
  //   font-size: 12px;
  // }
  /* 导航栏 */
  /* 导航栏 每个导航 */
  // #header .header-nav-m .header-nav-m-wrapper > li {
  //   height: 50px;
  //   line-height: 50px;
  //   border-bottom: 1px solid #ccc;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  // }
  /* 导航栏 每个导航下面的 a 链接 */
  // #header .header-nav-m .header-nav-m-wrapper > li > a {
  //   color: #fff;
  //   font-size: 15px;
  //   font-weight: bold;
  //   padding: 15px 0;
  //   position: relative;
  // }
  // /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  // #header .header-nav .header-nav-wrapper > li > a > span {
  //   font-size: 10px;
  // }
}
.s-nav-content {
  padding: 25px;
  display: flex;
  .s-nav-item {
    width: 180px;
    .title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      margin-bottom: 15px;
    }
    .s-nav-ul {
      margin: 0;
      padding: 0;
      > li {
        cursor: pointer;
        margin: 0;
        padding: 0;
        width: 100%;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
        > a {
          color: #333333;
          &:hover {
            color: #eb0029;
            text-decoration: none;
          }
        }
      }
    }
    &.abs {
      width: 66px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue